export type MenuSectionProps = { children: React.ReactNode };

/**
 * Section of a menu.
 *
 * @example
 * <MenuSection>
 *   <Heading>Tools</Heading>
 *   <MenuItem>Save Page As…</MenuItem>
 *   <MenuItem>Create Shortcut…</MenuItem>
 *   <MenuItem>Name Window…</MenuItem>
 *   <MenuItem>Developer Tools</MenuItem>
 * </MenuSection>
 */
export function MenuSection(props: MenuSectionProps) {
    return props.children;
}
